<ng-container *ngIf="author">
  <div class="media m-t-1">
    <div class="media-body">
      <div class="p-d-flex p-jc-between">
        <!-- Header title -->
        <div>
          <app-entity-follow-header
            [name]="author.name"
            [active]="isAuthorSaved"
            [ignored]="isAuthorIgnored"
            [allowIgnore]="true"
            [labels]="shortcutLabels"
            [activeLabel]="authorLabel"
            [isLoading]="isSavingAuthor"
            [showActions]="!hideFollowing"
            (toggled)="handleSaveAuthor(author)"
            (ignoreToggled)="handleIgnoreAuthor($event)"
            (labelToggled)="handleAuthorLabel($event)"
          ></app-entity-follow-header>
          <!-- Outlet associated -->
          <ul
            class="nav customizer-tab p-mb-4"
            style="padding: 0px; background: rgb(255, 255, 255)"
          >
            <li>
              <div class="row">
                <div class="col">
                  <h5>
                    <a
                      *ngIf="author.outletId; else outletName"
                      id="outletAssociated"
                      href="javascript:;"
                      role="button"
                      (click)="onDisplayOutletContent(author.outletId)"
                      >{{ author.outlet }}</a
                    >
                    <ng-template #outletName>{{ author.outlet }}</ng-template>
                  </h5>
                </div>
                <div class="col-md-auto">
                  <span *ngIf="author?.description">
                    {{ author.description | slice : 0 : 250 }}
                    <span *ngIf="author.description.length > 250"
                      >...
                      <a
                        href="javascript:void(0)"
                        (click)="
                          $event.preventDefault();
                          $event.stopPropagation();
                          descriptionPanel.toggle($event)
                        "
                        class="read-more-link"
                        >Read more</a
                      >
                    </span>
                  </span>
                  <p-overlayPanel
                    #descriptionPanel
                    [style]="{ 'max-width': '400px' }"
                    styleClass="description-overlay"
                    [baseZIndex]="100000"
                    appendTo="body"
                  >
                    <ng-template pTemplate="content">
                      <p style="margin: 0; white-space: pre-wrap">
                        {{ author.description }}
                      </p>
                    </ng-template>
                  </p-overlayPanel>
                </div>
              </div>
            </li>
          </ul>
          <!-- Social media contacts -->
          <ul
            class="nav customizer-tab"
            style="padding: 0px; background: rgb(255, 255, 255)"
          >
            <div class="row align-items-end">
              <li *ngIf="author.emailAddress && author.emailAddress != 'cbf'">
                <div class="row">
                  <div class="col-md-auto"></div>
                  <div class="col">
                    <a
                      href="mailto:{{ author.emailAddress }}"
                      [target]="'_blank'"
                    >
                      <i class="pi pi-envelope font-17 m-r-3"></i>
                      {{ author.emailAddress }}
                    </a>
                  </div>
                </div>
              </li>
              <li *ngIf="author?.contactUrl">
                <div class="row">
                  <div class="col-md-auto"></div>
                  <div class="col">
                    <a [href]="author?.contactUrl" [target]="'_blank'">
                      <i class="pi pi-globe font-17 m-r-3"></i>
                      Contact
                    </a>
                  </div>
                </div>
              </li>
              <li *ngIf="author.twitter && author.twitter != 'cbf'">
                <div class="row">
                  <div class="col-md-auto"></div>
                  <div class="col">
                    <a [href]="author.twitter" [target]="'_blank'">
                      <i class="pi pi-twitter font-17 m-r-3"></i>
                      X
                    </a>
                  </div>
                </div>
              </li>
              <li *ngIf="author.linkedIn && author.linkedIn != 'cbf'">
                <div class="row">
                  <div class="col-md-auto"></div>
                  <div class="col">
                    <a [href]="author.linkedIn" [target]="'_blank'">
                      <i class="pi pi-linkedin font-17 m-r-3"></i>
                      LinkedIn
                    </a>
                  </div>
                </div>
              </li>
              <li *ngIf="author.locationUrl">
                <div class="row">
                  <div class="col-md-auto"></div>
                  <div class="col">
                    <a [href]="author.locationUrl" [target]="'_blank'">
                      <i class="pi pi-map-marker font-17 m-r-3"></i>
                      {{ author.location }}
                    </a>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </div>

        <!-- Avatar image -->
        <div *ngIf="author?.picture">
          <img
            class="mt-4 mr-5 photo"
            [src]="author.picture"
            onerror="this.parentElement.style.display='none'"
          />
        </div>
      </div>
    </div>
  </div>

  <hr />
  <div *ngIf="hasReportingAccess() && author.myCompanyStats?.numItems > 0">
    <b
      >Mentioned {{ project.name }} {{ author.myCompanyStats?.numItems }} times,
      most recently on {{ author.myCompanyStats?.maxDate | date }}</b
    >
    <hr />
  </div>
  <div class="content-heading">
    <div>
      <label style="font-size: large"
        >Recent content by {{ author.name }}</label
      >
    </div>
    <div class="content-heading__action">
      <p-button
        class="p-button-sm coverage view-all-button"
        type="button"
        icon="pi pi-search"
        label="Search all content by {{ author.name }}"
        (click)="goToExploreRelatedCoverage(author)"
      ></p-button>
    </div>
  </div>
</ng-container>
<app-content-items
  [parentName]="parentName"
  [items]="contentItems"
  [loading]="!loading"
  [pageSize]="authorContentPageSize"
  [page]="currentPage"
  [total]="authorContentTotal"
  [keywords]="searchBody?.keywords"
></app-content-items>
<div id="paginator" class="p-d-flex p-jc-between">
  <div *ngIf="authorContentTotalPages >= 2">
    <p-paginator
      #pp
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ authorContentTotal | number }} total items"
      [pageLinkSize]="3"
      [showFirstLastIcon]="false"
      (onPageChange)="getPage($event)"
      [rows]="authorContentPageSize"
      [totalRecords]="authorContentTotal"
    >
    </p-paginator>
  </div>
  <div class="report-data-action">
    <p-button
      pTooltip="Report Missing Data"
      class="p-button-sm coverage report-data-button"
      icon="pi pi-flag"
      label=""
      (click)="openReportMissingDataModal()"
    ></p-button>
  </div>
  <div id="sort">
    <app-sort-options
      (sortChangesEmiter)="sortChange($event)"
      [defaultSort]="sortSelected"
    ></app-sort-options>
  </div>
</div>
